// @ Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// @ Components
import BrokerLegalDocumentationBox from './brokerLegalDocumentationBox';
// @ Commons
import {  OKBoxSectionContent } from 'commonsComponents/OKBoxSectionContent';
// @ Utils
const { FormattedText } = require('core/i18n').i18n;

class BrokerLegalDocumentation extends Component {

    renderContent = () => {
        const {
            documentType,
            fetchLegalDocuments,
            immBrokerFundLegalDocument,
            isin,
            iso,
            product,
            productDefinition,
            productType,
            secId,
            setLegalDocumentationChecked,
            reportCompleted,
            planDgsCode,
            isAportation,
            isSell,
            tealium,
            enableTransactionCost,
            pageName,
            enableEconomicReport,
        } = this.props;

        return (
            <BrokerLegalDocumentationBox
                documentType={documentType}
                fetchLegalDocuments={fetchLegalDocuments}
                immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                isin={isin}
                iso={iso}
                product={product}
                productDefinition={productDefinition}
                productType={productType.toUpperCase()}
                secId={secId}
                setLegalDocumentationChecked={setLegalDocumentationChecked}
                reportCompleted={reportCompleted}
                planDgsCode={planDgsCode}
                isAportation={isAportation}
                isSell={isSell}
                tealium={tealium}
                enableTransactionCost={enableTransactionCost}
                pageName={pageName}
                enableEconomicReport={enableEconomicReport}
            />
        )
    }
    render() {
        const { className } = this.props;
        return (
            <div className="broker-documentation">
                <OKBoxSectionContent
                    className={className}
                    headerContentLeft={<FormattedText value="brokerLegalDocumentation-title" />}
                    hasShadow={false}
                    hasBorder
                    content={this.renderContent()}
                >
                </OKBoxSectionContent>
            </div>
        );
    }
}

BrokerLegalDocumentation.propTypes = {
    className: PropTypes.string,
    documentType: PropTypes.string.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    isin: PropTypes.string,
    iso: PropTypes.string,
    product: PropTypes.string.isRequired,
    productDefinition: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    secId: PropTypes.string.isRequired,
    setLegalDocumentationChecked: PropTypes.func.isRequired,
    reportCompleted: PropTypes.func.isRequired,
    planDgsCode: PropTypes.string,
    isAportation: PropTypes.bool,
    isSell: PropTypes.bool,
    enableTransactionCost: PropTypes.bool,
    tealium: PropTypes.object,
    pageName: PropTypes.string,
    enableEconomicReport: PropTypes.bool,
};

BrokerLegalDocumentation.defaultProps = {
    enableTransactionCost: true,
    pageName: '',
    enableEconomicReport: true,
};

export default BrokerLegalDocumentation;
